<section class="page-wrap">

  <header class="pattern-header-producer" [class.pattern-header-producer--main]="mainProducer()">
    Producers
  </header>

  @defer (when !loadingProducers()) {

  @if (mainProducer()) {
  <section class="main-producer animated fadeInDown">
    <div class="container">

      <div class="picture">
        <img class="img" [src]="mainProducer()?.img" alt="Producer image" (error)="handleImageError($event)" />
        <img class="logo" src="/assets/images/logo-footer.webp"
          alt="Carlton Farms logo featuring silhouettes of a cow, pig, and chicken on a red background. Text reads: 'Carlton Farms, Rockmart, GA, Est. 1919, Pasture-Raised Meat, Milk & Eggs." />
      </div>

      <div class="info">

        <div>
          <h2 class="info__name" [routerLink]="['/pages/producers/' + mainProducer()?.detailUrl]">
            {{mainProducer()?.name}}
          </h2>
          <div class="info__location">
            <span class="material-symbols-outlined">location_on</span>
            <span>
              {{mainProducer()?.location}}
            </span>
          </div>
        </div>

        <p class="info__description" [innerHTML]="mainProducer()?.description"></p>

        <button type="button" class="btn btn-static btn-primary" [routerLink]="['/shop']"
          (click)="checkProducer(mainProducer()?.name ?? '')">
          Check Producer
        </button>

      </div>
    </div>
  </section>
  }

  <div class="container">
    <div class="position-relative">
      <div class="container">
        <div class="row">
          <div class="col-m12">
            <p class="h6-semibold">
              In addition to taking care of our farm, we work with other local farms and vendors to bring the best
              offerings. All of the products we carry must align with our guiding principles, and we have done the leg
              work for you, so you don't have to worry about what you are purchasing.
            </p>
          </div>
        </div>
        <div class="row">
          @if (producersCards()) {
          @for (producer of producersFilter(); track producer.id) {
          @defer (on viewport; prefetch on immediate) {
          <div class="col-lg-4 col-sm-6 animated fadeIn">
            <div class="card-producer">

              <img src="{{ producer.img }}" class="card-producer__img" alt="{{ producer.name }}"
                (error)="handleImageError($event)" />

              <div class="card-producer__container">

                <a [routerLink]="['/pages/producers/' + producer.detailUrl]">
                  <h3 class="card-producer__title">{{ producer.name }}</h3>
                </a>

                <hr>

                <div class="card-producer__location">
                  <span class="material-symbols-outlined">location_on</span>
                  <span>{{producer.location ?? ''}}</span>
                </div>

                <div class="card-producer__detail mb-2" [innerHTML]="producer.description"></div>

                <button type="button" class="btn btn-static btn-primary mt-2" [routerLink]="['/shop']"
                  (click)="checkProducer(producer.name)">
                  Check Producer
                </button>

              </div>

            </div>
          </div>
          } @placeholder {
          <div class="placeholder-glow animated fadeIn">
            <div class="col-xl-3 col-lg-4 col-sm-6 animated fadeIn bg-secondary"></div>
          </div>
          }
          }
          }
        </div>
      </div>
    </div>
  </div>
  } @placeholder (minimum 1s) {
  <div class="loading-animation-content">
    <div class="loader">
      @for (item of [0,0,0,0,0]; track $index) {
      <div class="bg-secondary"></div>
      }
    </div>
  </div>
  }

</section>